import DOMPurify from 'dompurify'

export const HtmlViewer = ({ html }: { html: string }) => {
    // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
    return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
}
